import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74394ea6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text_accent" }, " info@contec.kr ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contact" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", null, " GeoTools ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" ∙ "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://github.com/geotools/geotools",
      target: "_blank"
    }, " https://github.com/geotools/geotools ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, " ∙ LGPL-2.1 license ")
], -1))

import ModalTemplate from '@/components/common/modal/ModalTemplate.vue';
import useCommonStore from '@/store/storeCommon';


export default /*#__PURE__*/_defineComponent({
  __name: 'LicenseModal',
  setup(__props) {

const { showModal } = useCommonStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalTemplate, {
    transitionName: "fade",
    isModalOpen: _unref(showModal).isLicense,
    errorTitle: "OSS Notice",
    isLicenceMeteIcon: true
  }, {
    contentDescription: _withCtx(() => [
      _createTextVNode(" This application Copyright ⓒ 2024 CONTEC All rights Reserved."),
      _hoisted_1,
      _createTextVNode(" This application use Open Source Software (OSS)."),
      _hoisted_2,
      _createTextVNode("You can find the source code of these open source projects, along with applicable license information, below."),
      _hoisted_3,
      _createTextVNode("We are deeply grateful to these developers and their work and contributions."),
      _hoisted_4,
      _createTextVNode(" Any questions about our use of licensed work can be sent to "),
      _hoisted_5
    ]),
    contact: _withCtx(() => [
      _hoisted_6
    ]),
    _: 1
  }, 8, ["isModalOpen"]))
}
}

})